import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import FeatureBanner, {FeatureBannerItem} from 'ui-library/FeatureBanner';
import {Header1, Header3} from 'ui-library/Headers';

interface OrganizationSignInBannerProps {
  organizationName: string;
}

interface OrganizationFeatureBannerProps extends OrganizationSignInBannerProps {
  seenBannerPreference?: string;
}

export function OrganizationFeatureBanner({
  organizationName,
  seenBannerPreference,
}: OrganizationFeatureBannerProps): JSX.Element {
  return (
    <FeatureBanner className="u-lr-split" seenBannerPreference={seenBannerPreference}>
      <>
        {[
          {
            title: `Welcome to ${organizationName}`,
            subtitle: 'An easier way to collaborate with your labmates',
            imageSource: '/static/img/orgs/team-intro.svg',
            oversized: true,
          },
          {
            title: 'Share protocols, sequences, and projects',
            subtitle: `Create a shared library of resources for your entire team to use
            by adding your lab as a collaborator.`,
            imageSource: '/static/img/orgs/team-share.svg',
            oversized: false,
          },
          {
            title: 'Collaborate effortlessly',
            subtitle: `Share context with collaborators faster by @mentioning them in entries
            for lightweight reviews and references.`,
            imageSource: '/static/img/orgs/team-at-mention.svg',
            oversized: false,
          },
          {
            title: "See what your team's working on",
            subtitle: `View the team calendar to track what projects and plasmids
            your team is working on this month.`,
            imageSource: '/static/img/orgs/team-calendar.svg',
            oversized: false,
          },
        ].map((data, index) => (
          <FeatureBannerItem {...data} key={index} />
        ))}
      </>
    </FeatureBanner>
  );
}

export function OrganizationSignInBanner({organizationName}: OrganizationSignInBannerProps): JSX.Element {
  return (
    <FeatureBanner>
      <>
        <div className="featureBanner-item">
          <img
            src="/static/img/orgs/team-intro.svg"
            className="featureBanner-icon featureBanner-icon--large"
          />
          <div>
            <Header1>{`Welcome to ${organizationName}`}</Header1>
            <Header3>An easier way to collaborate with your labmates</Header3>
          </div>
        </div>
        <div className="featureBanner-item">
          <div className="organizationPage-featureBannerSubtext">
            Join Benchling to collaborate effortlessly with your teammates. Share protocols and sequences,
            @mention your teammates in entries, and plan your work out for the month!
            <form className="inlineForm inlineForm--secondary u-spacing-top" action="/signup">
              <input type="text" name="email" className="inlineForm-input inlineForm-input--medium" />
              <Button
                buttonStyle={ButtonStyle.PRIMARY}
                className="inlineForm-button"
                size={ButtonSize.SMALL}
                text="Signup"
              />
            </form>
          </div>
        </div>
      </>
    </FeatureBanner>
  );
}
